<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2 class="overview-header">Payment Arrangments</h2>
  </div>
</div>

<div class="row row2">
  <div class="conl-sm-12">
    <ul class="list-unstyled">
      <li><strong>{{streetAddress}}</strong></li>
      <li><small>{{cityStateZip}}</small></li>
      <li><small>{{acctNumber}}</small></li>
      <li>Below is an option to help manage your payments:</li>
    </ul>
  </div>
</div>

<div class="row row3">
  <div class="col-md-10">
    <div class="panel panel-card arrangements-top-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-eye payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">PrePay</p>
            <span class="card-sub-title">Pay off your balance over time.</span>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body arrangments-content">
          <p>Features include:</p>
          <ul>
            <li>Control over when you pay</li>
            <li>Set your balance notifications</li>
            <li>No reconnect fees</li>
            <li>Existing deposit is applied to help pay down your balance</li>
          </ul>
          <p>Start taking control of your account today and enroll in n prepay!</p>
          <p>Call 1-877-555-5555</p>
          <input type="button" class="btn btn-danger" value="GET MORE INFORMATION" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row row4">
  <div class="col-md-10">
    <div class="panel panel-card arrangements-bottom-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-calendar-alt payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Payment Arrangements</p>
            <span class="card-sub-title">Pay Your Full Balance by an Extended Date.</span>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body arrangments-content">
          <p>Sorry, we are unable to offer payment arrangements while enrolled in Auto Pay.</p>
          <p>All payment arrangement offers are the same whether using the online self-service options of automated phone system.</p>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/arrangements-container/arrangements-container.component.html